/**
 * 心成前台公開導覽詞條。
 *
 * 詞條用字取自舊系統：
 * - 「常見問題」= 舊站首頁導覽現存詞條（frontend/views/layouts/main.php
 *   → FrontendMenuHelper::renderMenu() 訪客可見項），路由 /faq。
 * - 其餘四項為 B1「網站管理」範圍內、業主裁決紀錄裁決 5-4 劃給 ccheng-web
 *   的 CMS 內容類型，詞條取自 admin 選單標籤（見
 *   migration/docs/用語對照表.md：Latest News=最新消息、Video Reels=活動剪影、
 *   Monthly Newsletter=心成月刊、Students Sharing=學長故事）。
 *
 * 舊站訪客（未登入）當下實際渲染的導覽僅剩「常見問題」一項——其餘會員/幹部
 * 選單皆以角色權限式的 visible 條件隱藏（見 FrontendMenuHelper.php 各
 * loadXxx()）。本檔納入的五項是 B1 批次要交付的公開內容路由，故詞條範圍
 * 以「製作順序規劃.md §4 B1」與本次任務指定的路由清單為準，而非逐項比對
 * 訪客目前看到的（幾乎全空的）舊選單。
 */
export interface SiteNavItem {
  label: string;
  href: string;
}

export const SITE_NAME = "心成教育";

/**
 * WP-B3-9（B3 課程牆前端）追加兩項——理由與詞條來源：
 * - 「1. 課程中心 ❤️」＝ `Yii::t('app','Courses')` 的 zh-TW 值（用語對照表 id 894，
 *   一字不差；那串序號與 emoji 是業主自己填在舊 message 表裡的，不是本批加的）。
 *   舊站這一項在 `FrontendMenuHelper::loadEnrolmentAndEnquiries()` 底下，
 *   `visible => Yii::$app->user->can('/courses/index')` ⇒ 訪客看不到。新棧的
 *   課程牆七支端點目前登記為 PUBLIC（差異已寫在 api 的 route_permissions note，
 *   ⛔ 待業主裁決），在會員層落地前若不放這一項，課程牆完全沒有入口。
 * - 「一階課程」＝ `Yii::t('app','Lv 1 Main Course')`（用語對照表 id 909），
 *   舊站 `loadOurCourses()` 底下 `visible => true`（**訪客本來就看得到**），
 *   網址 `level-1-main-course` ⇒ 新站 /courses/level-1-main-course。
 */
export const siteNavItems: SiteNavItem[] = [
  { label: "1. 課程中心 ❤️", href: "/courses" },
  { label: "一階課程", href: "/courses/level-1-main-course" },
  { label: "常見問題", href: "/faq" },
  { label: "最新消息", href: "/news" },
  { label: "學長故事", href: "/sharing" },
  { label: "活動剪影", href: "/videos" },
  { label: "心成月刊", href: "/newsletter" },
];
